
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
  directives: {
    TransferDom
  },
  props: [

  ],
  data() {
    return {
      content: '',
      showConfirm: false,
      confirm_title: '',
      onConfirm: '',
    }
  },
  computed: {
    activityId() {
      return this.$store.state.live.detail.Id
    },
    url() {
      return this.$route.params.pic
    },
  },
  methods: {
    publish() {
      if (this.validate()) {
        // 调用发布接口
        this.$store.dispatch({
          type: 'interactionPublish',
          title: this.content,
          picture: this.url,
          activityId: this.activityId
        }).then(res => {
          // 判断是否成功进行跳转
          if (res.status == 201) {
            // 跳转页面
            this.$vux.loading.show({
              text: '发布成功！'
            })
            setTimeout(() => {
              this.$vux.loading.hide()
              this.$router.go(-1)
            }, 1000)

          }
        }).catch(err => {
          console.log(err)
        })

      }
    },
    validate() {
      // 验证输入内容
      if (this.content.length == 0) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '还没有填写内容呢~'
        })
        return false
      }
      if (!this.url) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '没有上传图片哦'
        })
        return false
      }
      return true
    },
    cancel() {
      // if (confirm('确定放弃编辑的内容？')) {
      //   this.$router.go(-1)
      // }
      this.confirm_title = '确定放弃编辑的内容？'
      this.showConfirm = true
      this.onConfirm = () => this.$router.go(-1)
    }
  },
  watch: {
    $route: function() {
      this.content = ''
    }
  },
  components: {
    XTextarea,
    Group,
    Confirm
  }
}



// WEBPACK FOOTER //
// ./src/pages/live/InteractionPublish.vue